import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  background-color: #1B170C;
  padding: 80px 0;
  
  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;

export const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 32px;
  
  @media (max-width: 1024px) {
    padding: 0 32px;
  }
  
  @media (max-width: 768px) {
    padding: 0 32px;
  }
`;

export const Title = styled.h2`
  font-family: 'Mulish', sans-serif;
  font-weight: 700;
  font-size: 48px;
  line-height: 1.2;
  color: #FFFFFF;
  margin-bottom: 48px;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 32px;
    margin-bottom: 32px;
  }
`;

export const FAQList = styled.div`
  background-color: #211E19;
  border-radius: 24px;
  padding: 48px;
  
  @media (max-width: 768px) {
    padding: 8px 24px;
    border-radius: 16px;
  }
`;

export const FAQItem = styled.div`
  width: 100%;
`;

export const FAQHeader = styled.button`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: none;
  border: none;
  padding: 24px 0;
  cursor: pointer;
  text-align: left;
  
  @media (max-width: 768px) {
    padding: 20px 0;
    gap: 12px;
  }
`;

export const QuestionNumber = styled.span`
  font-family: 'Mulish', sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.4;
  color: #FFFFFF;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const QuestionText = styled.span`
  font-family: 'Mulish', sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.4;
  color: #FFFFFF;
  flex: 1;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const ExpandIcon = styled.span<{ isOpen: boolean }>`
  font-family: 'Mulish', sans-serif;
  font-weight: 300;
  font-size: 32px;
  line-height: 1;
  color: #FFFFFF;
  flex-shrink: 0;
  transition: transform 0.3s ease;
  
  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

export const FAQAnswer = styled.div<{ isOpen: boolean }>`
  font-family: 'Mulish', sans-serif;
  font-weight: 300;
  font-size: 16px;
  line-height: 1.6;
  color: #D1D5DB;
  padding-left: 36px;
  max-height: ${props => props.isOpen ? '500px' : '0'};
  opacity: ${props => props.isOpen ? '1' : '0'};
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease;
  padding-bottom: ${props => props.isOpen ? '24px' : '0'};
  
  @media (max-width: 768px) {
    padding-left: 28px;
    font-size: 14px;
    padding-bottom: ${props => props.isOpen ? '20px' : '0'};
  }
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #3A3730;
  margin: 0;
`;

